<template>
  <div>
    <b-button variant="outline-light" v-on:click="detayaGit()"
      ><Icon
        icon="akar-icons:search"
        width="20"
        height="20"
        v-b-tooltip.hover.bottom="'DETAY'"
        color="#7367F0"
    /></b-button>
    <b-button variant="outline-light" v-on:click="stokEkstre()"
      ><Icon
        icon="material-symbols:receipt-long"
        width="20"
        height="20"
        v-b-tooltip.hover.bottom="'Ekstre'"
        color="#FF9F43"
    /></b-button>
    <StokEkstre ref="ekstre" />
    <!--
    <b-button variant="outline-light" v-on:click="uretimSil()"
      ><Icon
        icon="ic:outline-auto-delete"
        width="20"
        height="20"
        v-b-tooltip.hover.bottom="'Sil'"
        color="#EA5455"
    /></b-button>-->
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import StokEkstre from "./StokEkstre.vue";
export default {
  components: { Icon, StokEkstre },
  methods: {
    detayaGit() {
      let uretimValItem = { item: this.params.data };
      this.$root.$emit("getSuggestionUretimVal", uretimValItem, "UPDATE");
    },
    uretimSil() {
      let uretimValItem = { item: this.params.data };
      this.$root.$emit("uretimKaydet", 0, "DEL",this.params.data.RECEIPTID, this.params.data.detay );
    },
    stokEkstre() {
      this.$store.commit(
        "account/STOKSTOCKNAME_TUT",
        this.params.data.STOCKNAME
      );
      this.$store.commit("account/STOKID_TUT", this.params.data.STOCKID);
      this.$store.commit("account/STOKSTOCKNO_TUT", this.params.data.STOCKNO);
      this.$refs.ekstre.stokEkstreDetay( this.params.data.STOCKNO, this.params.data.STOCKNAME);
      // this.$store.commit("account/STOCKIDALTER_TUT", this.params.data.STOCKIDALTER);
    },
  }
};
</script>
